import React, {useState} from "react";
import styled from "styled-components";
import { Box, Flex } from "../../assets/ui";
import TopNav from "../TopNav";
import BannerWorkWithUs from "../BannerWorkWithUs";
import GiveUp from "../../components/GiveUp";
import Footer from "../Footer";
import BannerJobDetails from "../BannerJobDetails";
import JobInfoSection from "./JobInfoSection";
import { rolesData } from "../OpenRoles";
import SportVenue from "./SportVenue";
import ExperiencedInSales from "./ExperiencedInSales";
import JoinUs from "./JoinUs";
import ApplicationForm from "./ApplicationForm";

const FirstScreenWrapper = styled(Flex)`
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 6.4e-5) -32.78%,
      rgba(21, 31, 44, 0.64) 84.76%
    ),
    linear-gradient(0deg, rgba(22, 32, 45, 0.96), rgba(22, 32, 45, 0.96)),
    url("/images/banner-job-details.png");
  background-blend-mode: normal, multiply, normal;
  min-height: 100vh;
  background-size: auto 100%;
  background-position: 0% center;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 15%;
  @media (min-width: ${({ theme }) => theme.queries.xl}) {
    background-size: 105% auto;
  }
`;

const JobDetails = ({ match }) => {
    const [showModal, toggleModal] = useState(false);

    const currentJob = rolesData[match.params.id];
  return (
    <div>
        {showModal && <ApplicationForm toggleModal={toggleModal} job={currentJob}/>}

      <FirstScreenWrapper>
        <TopNav />
        <BannerJobDetails job={currentJob} toggleModal={toggleModal}/>
      </FirstScreenWrapper>
      <JobInfoSection job={currentJob} />
      <SportVenue />
      <JoinUs />
      <ExperiencedInSales />
      <GiveUp />
      <Footer />
    </div>
  );
};

export default JobDetails;
